import { createSlice } from "@reduxjs/toolkit";
import { defaultDateRange, defaultPlayerDateRange } from "../utils/reuse";

// Slice for alerts filter
const alertFilterSlice = createSlice({
  name: 'alertFilter',
  initialState: {},
  reducers: {
    setFilter(state, action) {
      return action.payload;
    },
    resetFilter() {
      return {};
    }
  }
});

// Slice for reports filter
const reportFilterSlice = createSlice({
  name: 'reportFilter',
  initialState: {},
  reducers: {
    setReportFilter(state, action) {
      return action.payload;
    },
    resetReportFilter() {
      return {};
    }
  }
});
const date = (() => {
  const nowUTC = new Date(new Date().toUTCString());
  const hourUTC = nowUTC.getUTCHours();

  const offsetDays = hourUTC >= 21 ? 1 : 2;

  const maxAllowedDate = new Date();
  maxAllowedDate.setUTCDate(nowUTC.getUTCDate() - offsetDays);

  return [maxAllowedDate, maxAllowedDate];
})();
// Slice for Alert platform filter
const alertPlatformFilterSlice = createSlice({
  name: 'alertPlatformFilter',
  initialState: {
    bettingDataFilters: {
      events: [],
      sports: [],
      tournaments: [],
      players: [],
      locations: [],
      date: { date: date },
      channel: null,
      playerID: ''
    },
    playerFilters: {
      date: null,
      channel: null,
      playerID: ''
    },
    anomalieFilters: {
      date: null,
      channel: null,
      reviewed: false,
      types:"all",
      listView: false
    },
    baselineFilters: {
      baselineSports: [],
      tournamentKeywordSearch: "",
      type: 'sport'
     }
  },
  reducers: {
    storeAlertPlatFormFilters(state, action) {
      state.bettingDataFilters = action.payload
    },
    storePlayerFilters(state, action) {
      state.playerFilters = { ...state.playerFilters, ...action.payload }
    },
    storeAnomalieFilters(state, action) {
      state.anomalieFilters = { ...state.anomalieFilters, ...action.payload }
    },
    storeBaselineFilters(state, action) {
      state.baselineFilters = { ...state.baselineFilters, ...action.payload }
    },
    resetAlertPlatFormFilters(state) {
      state.bettingDataFilters = {
        events: [],
        sports: [],
        tournaments: [],
        players: [],
        locations: [],
        date: null,
        channel: null,
        playerID: ''
      };
      state.playerFilters = {
        date: null,
        channel: null,
        playerID: ''
      }
      state.anomalieFilters = {
        date: null,
        channel: null,
        reviewed: false,
        types:"all",
        listView: false
      }
      state.baselineFilters = {
        baselineSports: [],
        tournamentKeywordSearch: "",
        type: 'sport'
      }
    }
  }
});
// Slice for Alert platform filter
const userFilterSlice = createSlice({
  name: 'userFilter',
  initialState: {
    role: [],
    search: '',
  },
  reducers: {
    storeUserfFilters(state, action) {
      return action.payload;
    },
    resetUserFilters() {
      return {
        role: [],
        search: '',
      };
    }
  }
});
const memberAnalyticsFilterSlice = createSlice({
  name: 'memberAnalyticsFilter',
  initialState: {
    dateRange: defaultDateRange,
    playerDateRange: defaultPlayerDateRange,
    marketDateRange: defaultPlayerDateRange,
    reportsDateRange: defaultDateRange,
    memberDateRange: defaultDateRange,
    memberPlayerDateRange: defaultPlayerDateRange,
    memberMarketDateRange: defaultPlayerDateRange,
  },
  reducers: {
    storeDateRange(state, action) {
      state.dateRange = action.payload;
    },
    storeMemberDateRange(state, action) {
      state.memberDateRange = action.payload;
    },
    storePlayerDateRange(state, action) {
      state.playerDateRange = action.payload;
    },
    storeMemberPlayerDateRange(state, action) {
      state.memberPlayerDateRange = action.payload;
    },
    storeMarketDateRange(state, action) {
      state.marketDateRange = action.payload;
    },
    storeMemberMarketDateRange(state, action) {
      state.memberMarketDateRange = action.payload;
    },
    storeReportsDateRange(state, action) {
      state.reportsDateRange = action.payload;
    },
    resetDateRange(state) {
      state.dateRange = defaultDateRange;
    },
    resetPlayerDateRange(state) {
      state.playerDateRange = defaultPlayerDateRange;
    },
    resetMarketDateRange(state) {
      state.marketDateRange = defaultPlayerDateRange;
    },
    resetReportsDateRange(state) {
      state.reportsDateRange = defaultDateRange;
    },
    resetMemberDateRange(state) {
      state.memberDateRange = defaultDateRange;
    },
    resetMemberPlayerDateRange(state) {
      state.memberPlayerDateRange = defaultPlayerDateRange;
    },
    resetMemberMarketDateRange(state) {
      state.memberMarketDateRange = defaultPlayerDateRange;
    }
  }
});

export const { setFilter, resetFilter } = alertFilterSlice.actions;
export const { setReportFilter, resetReportFilter } = reportFilterSlice.actions;
export const { storeAlertPlatFormFilters, resetAlertPlatFormFilters, storePlayerFilters, storeAnomalieFilters, storeBaselineFilters } = alertPlatformFilterSlice.actions;
export const { storeUserfFilters, resetUserFilters } = userFilterSlice.actions;
export const { storeDateRange, storePlayerDateRange, storeMarketDateRange, storeReportsDateRange, storeMemberDateRange, storeMemberPlayerDateRange, storeMemberMarketDateRange, resetDateRange, resetPlayerDateRange, resetMarketDateRange, resetReportsDateRange, resetMemberDateRange, resetMemberPlayerDateRange, resetMemberMarketDateRange } = memberAnalyticsFilterSlice.actions;

export const alertFilterReducer = alertFilterSlice.reducer;
export const reportFilterReducer = reportFilterSlice.reducer;
export const alertPlatformReducer = alertPlatformFilterSlice.reducer;
export const userFilterReducer = userFilterSlice.reducer;
export const memberAnalyticsFilterReducer = memberAnalyticsFilterSlice.reducer;